<template>
  <div class="rt-tag">
    <slot name="icon"> <rt-icon :name="icon" size="14"></rt-icon> </slot>
    <span class="rt-tag-text"> <slot /> </span>
  </div>
</template>

<script>
export default {
  name: 'RtTag',
  props: {
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="less">
.rt-tag {
  display: flex;
  align-items: center;
  background: #f8fafd;
  padding: 2px 10px;
  margin-right: 8px;
  border-radius: 2px;
  .rt-icon {
    margin-right: 8px;
    line-height: 1;
  }
  span.rt-tag-text {
    color: #6388c2;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// rtTag.vue?60cdf802